import { API_REQUEST, GET_SECURITY_QUESTION, GET_SECURITY_QUESTIONS } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const getSecurityQuestion = (userId: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/get-question/${userId}`,
        next: GET_SECURITY_QUESTION,
        method: 'GET',
        authorization: true
    }
});

export const getSecurityQuestions = (userId: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/get-questions/${userId}`,
        next: GET_SECURITY_QUESTIONS,
        method: 'GET',
        authorization: true
    }
});